import React from 'react';
import moment from 'moment';

import {
    Card,
    Table,
    Button,
} from 'antd';

import NewVmModal from './modal';
import VmViewer from './viewer/index';
import EnterpriseSelector from './enterprise-selector';

import {
    _getVms,
} from '../../services'

class VmManager extends React.Component {

    constructor(props) {
        super(props) 
        this.state = {
            vms: [],

            newVmModalVisible: false,
            activeVm: false,
        }
    }

    render() {
        return (
            <div>
                <Card
                    title={
                        <Button onClick={this.handleNewVmClicked}>New VM</Button>
                    }>
                    {this.renderVmTable()}
                    {this.state.newVmModalVisible && <NewVmModal
                        vmData={this.state.activeVm}
                        newVmModalVisible={this.state.newVmModalVisible}
                        closeVmModal={this.closeVmModal}
                        />}
                </Card>

                <VmViewer />
            </div>
        )
    }

    componentDidMount() {
        this.getVms()
    }

    getVms = () => {
        _getVms()
        .then(_vms =>{
            this.setState({
                vms: _vms.data
            })
        })
    }

    renderVmTable = () => {

        const columns = [{
            title: 'Name',
            dataIndex: 'name',
        },{
            title: 'Address',
            dataIndex: 'address.address',
        },{
            title: 'Postal Code',
            dataIndex: 'address.postalCode',
        },{
            title: 'Building',
            dataIndex: 'address.building',
        },{
            title: 'Unit',
            dataIndex: 'address.unit',
        },{
            title: 'Postal Code',
            dataIndex: 'address.postalCode',
        },{
            title: 'Public',
            dataIndex: 'public',
            render: (publicBool) => publicBool ? 'TRUE' : 'FALSE'
        },{
            title: 'Enterprise Id',
            dataIndex: 'enterpriseId',
            render: (enterpriseId) => enterpriseId ? enterpriseId : '-'
        },{
            title: 'Dept Codes',
            dataIndex: 'departmentCode',
            render: (depCode) => depCode ? depCode.reduce((acc,cur) => {return `${acc} ${cur}`},'') : '-'
        },{
            title: 'Actions',
            dataIndex: '_id',
            render: (vmId) => this.renderActions(vmId)
        }]

        return(
            <Table
                columns={columns}
                dataSource={this.state.vms}
                pagination={false}
            />
        )

    }

    renderActions = (vmId) => {
        return(
            <div className='button-container'>
                <Button onClick={() => this.handleEditVmClicked(vmId)}>Edit</Button> 
            </div>
        )
    }

    handleNewVmClicked = () => {
        this.setState({
            newVmModalVisible: true
        })
    }

    handleEditVmClicked = (vmId) => {

        const selectedVm = this.state.vms.filter(_vm => `${_vm._id}` == vmId)[0]

        this.setState({
            activeVm: selectedVm,
            newVmModalVisible: true
        })

    }

    closeVmModal = () => {
        this.setState({
            newVmModalVisible: false
        },this.getVms)
    }

}

export default VmManager


// WEBPACK FOOTER //
// ./src/components/vm/manager.js